import React from "react";
import { Link } from 'react-router-dom';

export default function PlusLoinMariage(args) {

    return (
        <>
            <blockquote className="blog-quote">
                <b>Pour aller plus loin sur le contrat de mariage :</b><br />
                <Link to="/contrat-mariage/notaire/regimes-matrimoniaux" >Quel régime matrimonial choisir ?</Link><br />
                <Link to="/outils/calculateur-frais-de-notaire-immobilier">Quel est prix d'un contrat de mariage ?</Link><br />
                <Link to="/contrat-mariage/notaire/pourquoi-faire-un-contrat-de-mariage">Pourquoi faire un contrat de mariage ?</Link>
            </blockquote>
        </>
    );
}
